// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mpyprutumezvlnwtbaxu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1weXBydXR1bWV6dmxud3RiYXh1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDAyNTI4NTYsImV4cCI6MjA1NTgyODg1Nn0.PJIBQpQBQ4JYJboGIBl2FWS2Pv79q5rnOSDtTQhuHgo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);